import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  scheduledLoading: false,
  error: null,
  messageLog: [],
  scheduled: [],
  pagination: {},
};

export const messageSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setScheduledLoading: (state) => {
      state.scheduledLoading = true;
    },
    setMessageLog: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.messageLog = payload;
    },
    setScheduled: (state, { payload }) => {
      state.scheduledLoading = false;
      state.error = null;
      state.scheduled = payload;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.scheduledLoading = false;
      state.error = payload;
    },
    setPagination: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.pagination = payload;
    },
    smsSent: (state, { payload }) => {
      // Track SMS sent immediately
      state.loading = false;
    },
    smsScheduled: (state, { payload }) => {
      // Track SMS scheduled for later
      state.loading = false;
    },
    scheduledSmsSent: (state, { payload }) => {
      // Track scheduled SMS sent now
      state.loading = false;
    },
    smsRescheduled: (state, { payload }) => {
      // Track SMS rescheduled
      state.loading = false;
    },
    scheduleCancelled: (state, { payload }) => {
      // Track schedule cancelled
      state.loading = false;
    },
  },
});

export const {
  setLoading,
  setScheduledLoading,
  setMessageLog,
  setScheduled,
  setError,
  setPagination,
  smsSent,
  smsScheduled,
  scheduledSmsSent,
  smsRescheduled,
  scheduleCancelled,
} = messageSlice.actions;

export default messageSlice.reducer;

export const messageSelector = (state) => state.messages;
